import { Navigate, type RouteObject } from 'react-router-dom';

import { FeatureFlagGuard } from '@platform/client/feature-flags';

import NotFoundPage from '@packages/core/pages/not-found-v2/not-found-v2.page';

declare module '@platform/core/feature-flags' {
  interface FeatureFlags {
    ACCESS_CONTROL?: boolean;
  }
}

export const accessControlRoutes: RouteObject = {
  path: '/access-control',
  errorElement: <NotFoundPage />,
  element: <FeatureFlagGuard featureFlag="ACCESS_CONTROL" />,
  children: [
    {
      index: true,
      element: <Navigate to="accounts" replace />,
    },
    {
      lazy: () => import('./pages/access-control/access-control.layout'),
      children: [
        {
          path: 'accounts',
          index: true,
          lazy: () => import('./pages/accounts-page/accounts.page'),
        },
        {
          path: 'roles',
          lazy: () => import('./pages/roles-page/roles.page'),
        },
        {
          path: 'permissions',
          lazy: () => import('./pages/permissions-page/permissions.page'),
        },
      ],
    },
    {
      path: 'accounts/detail/:loginId',
      lazy: () =>
        import(
          './pages/accounts-page/account-details-page/account-details-page'
        ),
    },
    {
      path: 'roles/:id',
      lazy: () => import('./pages/roles-page/roles-details/roles-details.page'),
      children: [
        {
          index: true,
          element: <Navigate to="accounts" replace />,
        },
        {
          lazy: () =>
            import('./pages/roles-page/roles-details/roles-details.layout'),
          children: [
            {
              path: 'accounts',
              index: true,
              lazy: () =>
                import(
                  './pages/roles-page/roles-details/accounts-table/accounts-table'
                ),
            },
            {
              path: 'permissions',
              lazy: () =>
                import(
                  './pages/roles-page/roles-details/permissions-table/permissions-table'
                ),
            },
          ],
        },
      ],
    },
    {
      path: 'edit-role/:id',
      lazy: () => import('./pages/edit-role/edit-role.page'),
    },
    {
      path: 'clone-role/:id',
      lazy: () => import('./pages/clone-role/clone-role.page'),
    },
    {
      path: 'create-role',
      lazy: () => import('./pages/create-role/create-role.page'),
    },
  ],
};
